import React from 'react';
import { motion } from 'framer-motion';
import { XCircle } from 'lucide-react';
export function PainPoints() {
  const points = ['Ruidos en pleno silencio que te hacen querer desaparecer.', 'Pinchazos que aparecen sin aviso y arruinan el momento.', 'La sensación de que todo te cae mal aunque comiste liviano.', 'Miedo constante a comer afuera sin saber cómo va a reaccionar tu panza.', 'Pastillas que tapan el síntoma pero no resuelven nada de fondo.', 'Meses o años buscando respuestas. Cada solución fue solo temporal.'];
  return <section className="py-24 bg-brand-black relative overflow-hidden" data-id="element-155">
      {/* Subtle background element */}
      <div className="absolute top-0 right-0 w-1/2 h-full bg-gradient-to-l from-red-900/5 to-transparent pointer-events-none" data-id="element-156" />

      <div className="container mx-auto px-4 relative z-10" data-id="element-157">
        <div className="max-w-4xl mx-auto" data-id="element-158">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-center mb-16" data-id="element-159">
            <h2 className="md:text-5xl font-bold mb-6 font-[Poppins,_sans-serif] text-[22px]" data-id="element-160">
              ¿Seguís cancelando planes por culpa de tu panza?
            </h2>
            <p className="text-gray-300 mb-4 text-[16px]" data-id="element-161">
              Ya probaste dejar el gluten, los lácteos y las harinas, pero el
              ruido y el dolor siempre vuelven.
            </p>
            <p className="text-gray-300 mb-4 text-[16px]" data-id="element-162">
              ¿Por qué? Porque tu problema no es lo que comés, sino tu sistema
              nervioso. Tu intestino está en "modo alerta" y reacciona de más
              ante cualquier alimento.
            </p>

            <p className="font-medium mt-4 text-[#22C55E] text-[18px]" data-id="element-163">
              No es la edad. Es falta de un sistema de desactivación.
            </p>
          </motion.div>

          <div className="grid gap-4 md:gap-6 mb-16" data-id="element-164">
            {points.map((point, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className="flex items-start gap-4 bg-[#2a0a0a] p-5 rounded-xl border border-red-900/80" data-id="element-165">
                <XCircle className="w-6 h-6 text-red-500 shrink-0 mt-0.5" data-id="element-166" />
                <p className="text-lg text-gray-200" data-id="element-167">{point}</p>
              </motion.div>)}
          </div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} className="text-center" data-id="element-168">
            <h3 className="text-2xl md:text-4xl font-bold text-brand-gold italic font-[Inter,_sans-serif]" data-id="element-169">
              ¿Y si pudieras sentarte en cualquier mesa sin ese miedo, desde
              hoy?
            </h3>
          </motion.div>
        </div>
      </div>
    </section>;
}